// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  User,
  UserFromJSON,
  UserToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface IssueComment
 */
export interface IssueComment {
  /**
   *
   * @type {number}
   * @memberof IssueComment
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof IssueComment
   */
  issue?: number;
  /**
   *
   * @type {number}
   * @memberof IssueComment
   */
  project?: number;
  /**
   *
   * @type {Array<User>}
   * @memberof IssueComment
   */
  mentions?: Array<User>;
  /**
   *
   * @type {string}
   * @memberof IssueComment
   */
  comment: string;
  /**
   *
   * @type {UserMinified}
   * @memberof IssueComment
   */
  createdBy: UserMinified;
  /**
   *
   * @type {UserMinified}
   * @memberof IssueComment
   */
  updatedBy?: UserMinified;
  /**
   *
   * @type {string}
   * @memberof IssueComment
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof IssueComment
   */
  updatedAt?: string;
}

export function IssueCommentFromJSON(json: any): IssueComment {
  return {
    id: json["id"],
    issue: !exists(json, "issue") ? undefined : json["issue"],
    project: !exists(json, "project") ? undefined : json["project"],
    mentions: !exists(json, "mentions")
      ? undefined
      : (json["mentions"] as Array<any>).map(UserFromJSON),
    comment: json["comment"],
    createdBy: UserMinifiedFromJSON(json["created_by"]),
    updatedBy: !exists(json, "updated_by")
      ? undefined
      : UserMinifiedFromJSON(json["updated_by"]),
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function IssueCommentToJSON(value?: IssueComment): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    issue: value.issue,
    project: value.project,
    mentions:
      value.mentions === undefined
        ? undefined
        : (value.mentions as Array<any>).map(UserToJSON),
    comment: value.comment,
    created_by: UserMinifiedToJSON(value.createdBy),
    updated_by: UserMinifiedToJSON(value.updatedBy),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}
